// Generated templeMediaMap mapping each temple to its authentic images
export const templeMediaMap = {
  "mahakaleshwar-ujjain": {
    "timingImage": "/assets/temple-images/mahakaleshwar-ujjain/timing.jpg",
    "aarti1": "/assets/temple-images/mahakaleshwar-ujjain/aarti1.jpg",
    "aarti2": "/assets/temple-images/mahakaleshwar-ujjain/aarti2.jpg"
  },
  "tirupati-balaji": {
    "timingImage": "/assets/temple-images/tirupati-balaji-temple/timing.jpg",
    "aarti1": "/assets/temple-images/tirupati-balaji-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/tirupati-balaji-temple/aarti2.jpg"
  },
  "tirupati-balaji-temple": {
    "timingImage": "/assets/temple-images/tirupati-balaji-temple/timing.jpg",
    "aarti1": "/assets/temple-images/tirupati-balaji-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/tirupati-balaji-temple/aarti2.jpg"
  },
  "shirdi-sai-baba": {
    "timingImage": "/assets/temple-images/shirdi-sai-baba-temple/timing.jpg",
    "aarti1": "/assets/temple-images/shirdi-sai-baba-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/shirdi-sai-baba-temple/aarti2.jpg"
  },
  "shirdi-sai-baba-temple": {
    "timingImage": "/assets/temple-images/shirdi-sai-baba-temple/timing.jpg",
    "aarti1": "/assets/temple-images/shirdi-sai-baba-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/shirdi-sai-baba-temple/aarti2.jpg"
  },
  "jagannath-puri": {
    "timingImage": "/assets/temple-images/jagannath-temple-puri/timing.jpg",
    "aarti1": "/assets/temple-images/jagannath-temple-puri/aarti1.jpg",
    "aarti2": "/assets/temple-images/jagannath-temple-puri/aarti2.jpg"
  },
  "jagannath-temple-puri": {
    "timingImage": "/assets/temple-images/jagannath-temple-puri/timing.jpg",
    "aarti1": "/assets/temple-images/jagannath-temple-puri/aarti1.jpg",
    "aarti2": "/assets/temple-images/jagannath-temple-puri/aarti2.jpg"
  },
  "baidyanath-dham": {
    "timingImage": "/assets/temple-images/baidyanath-temple-deoghar/timing.jpg",
    "aarti1": "/assets/temple-images/baidyanath-temple-deoghar/aarti1.jpg",
    "aarti2": "/assets/temple-images/baidyanath-temple-deoghar/aarti2.jpg"
  },
  "baidyanath-temple-deoghar": {
    "timingImage": "/assets/temple-images/baidyanath-temple-deoghar/timing.jpg",
    "aarti1": "/assets/temple-images/baidyanath-temple-deoghar/aarti1.jpg",
    "aarti2": "/assets/temple-images/baidyanath-temple-deoghar/aarti2.jpg"
  },
  "somnath-temple": {
    "timingImage": "/assets/temple-images/somnath-temple/timing.jpg",
    "aarti1": "/assets/temple-images/somnath-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/somnath-temple/aarti2.jpg"
  },
  "sabarimala": {
    "timingImage": "/assets/temple-images/sabarimala-ayyappa-temple/timing.jpg",
    "aarti1": "/assets/temple-images/sabarimala-ayyappa-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/sabarimala-ayyappa-temple/aarti2.jpg"
  },
  "sabarimala-ayyappa-temple": {
    "timingImage": "/assets/temple-images/sabarimala-ayyappa-temple/timing.jpg",
    "aarti1": "/assets/temple-images/sabarimala-ayyappa-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/sabarimala-ayyappa-temple/aarti2.jpg"
  },
  "omkareshwar": {
    "timingImage": "/assets/temple-images/omkareshwar-temple/timing.jpg",
    "aarti1": "/assets/temple-images/omkareshwar-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/omkareshwar-temple/aarti2.jpg"
  },
  "omkareshwar-temple": {
    "timingImage": "/assets/temple-images/omkareshwar-temple/timing.jpg",
    "aarti1": "/assets/temple-images/omkareshwar-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/omkareshwar-temple/aarti2.jpg"
  },
  "guruvayur-temple": {
    "timingImage": "/assets/temple-images/guruvayur-temple/timing.jpg",
    "aarti1": "/assets/temple-images/guruvayur-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/guruvayur-temple/aarti2.jpg"
  },
  "banke-bihari": {
    "timingImage": "/assets/temple-images/banke-bihari-temple-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/banke-bihari-temple-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/banke-bihari-temple-vrindavan/aarti2.jpg"
  },
  "banke-bihari-temple-vrindavan": {
    "timingImage": "/assets/temple-images/banke-bihari-temple-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/banke-bihari-temple-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/banke-bihari-temple-vrindavan/aarti2.jpg"
  },
  "siddhivinayak-mumbai": {
    "timingImage": "/assets/temple-images/siddhivinayak-temple-mumbai/timing.jpg",
    "aarti1": "/assets/temple-images/siddhivinayak-temple-mumbai/aarti1.jpg",
    "aarti2": "/assets/temple-images/siddhivinayak-temple-mumbai/aarti2.jpg"
  },
  "siddhivinayak-temple-mumbai": {
    "timingImage": "/assets/temple-images/siddhivinayak-temple-mumbai/timing.jpg",
    "aarti1": "/assets/temple-images/siddhivinayak-temple-mumbai/aarti1.jpg",
    "aarti2": "/assets/temple-images/siddhivinayak-temple-mumbai/aarti2.jpg"
  },
  "ambaji-temple": {
    "timingImage": "/assets/temple-images/ambaji-temple-gujarat/timing.jpg",
    "aarti1": "/assets/temple-images/ambaji-temple-gujarat/aarti1.jpg",
    "aarti2": "/assets/temple-images/ambaji-temple-gujarat/aarti2.jpg"
  },
  "ambaji-temple-gujarat": {
    "timingImage": "/assets/temple-images/ambaji-temple-gujarat/timing.jpg",
    "aarti1": "/assets/temple-images/ambaji-temple-gujarat/aarti1.jpg",
    "aarti2": "/assets/temple-images/ambaji-temple-gujarat/aarti2.jpg"
  },
  "kalika-mata-pavagadh": {
    "timingImage": "/assets/temple-images/pavagadh-kalika-mata-temple/timing.jpg",
    "aarti1": "/assets/temple-images/pavagadh-kalika-mata-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/pavagadh-kalika-mata-temple/aarti2.jpg"
  },
  "pavagadh-kalika-mata-temple": {
    "timingImage": "/assets/temple-images/pavagadh-kalika-mata-temple/timing.jpg",
    "aarti1": "/assets/temple-images/pavagadh-kalika-mata-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/pavagadh-kalika-mata-temple/aarti2.jpg"
  },
  "meenakshi-amman": {
    "timingImage": "/assets/temple-images/meenakshi-amman-temple-madurai/timing.jpg",
    "aarti1": "/assets/temple-images/meenakshi-amman-temple-madurai/aarti1.jpg",
    "aarti2": "/assets/temple-images/meenakshi-amman-temple-madurai/aarti2.jpg"
  },
  "meenakshi-amman-temple-madurai": {
    "timingImage": "/assets/temple-images/meenakshi-amman-temple-madurai/timing.jpg",
    "aarti1": "/assets/temple-images/meenakshi-amman-temple-madurai/aarti1.jpg",
    "aarti2": "/assets/temple-images/meenakshi-amman-temple-madurai/aarti2.jpg"
  },
  "krishna-janmabhoomi": {
    "timingImage": "/assets/temple-images/krishna-janmabhoomi-mathura/timing.jpg",
    "aarti1": "/assets/temple-images/krishna-janmabhoomi-mathura/aarti1.jpg",
    "aarti2": "/assets/temple-images/krishna-janmabhoomi-mathura/aarti2.jpg"
  },
  "krishna-janmabhoomi-mathura": {
    "timingImage": "/assets/temple-images/krishna-janmabhoomi-mathura/timing.jpg",
    "aarti1": "/assets/temple-images/krishna-janmabhoomi-mathura/aarti1.jpg",
    "aarti2": "/assets/temple-images/krishna-janmabhoomi-mathura/aarti2.jpg"
  },
  "khatu-shyam": {
    "timingImage": "/assets/temple-images/khatu-shyam-ji-rajasthan/timing.jpg",
    "aarti1": "/assets/temple-images/khatu-shyam-ji-rajasthan/aarti1.jpg",
    "aarti2": "/assets/temple-images/khatu-shyam-ji-rajasthan/aarti2.jpg"
  },
  "khatu-shyam-ji-rajasthan": {
    "timingImage": "/assets/temple-images/khatu-shyam-ji-rajasthan/timing.jpg",
    "aarti1": "/assets/temple-images/khatu-shyam-ji-rajasthan/aarti1.jpg",
    "aarti2": "/assets/temple-images/khatu-shyam-ji-rajasthan/aarti2.jpg"
  },
  "prem-mandir": {
    "timingImage": "/assets/temple-images/prem-mandir-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/prem-mandir-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/prem-mandir-vrindavan/aarti2.jpg"
  },
  "prem-mandir-vrindavan": {
    "timingImage": "/assets/temple-images/prem-mandir-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/prem-mandir-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/prem-mandir-vrindavan/aarti2.jpg"
  },
  "padmanabhaswamy-temple": {
    "timingImage": "/assets/temple-images/padmanabhaswamy-temple-kerala/timing.jpg",
    "aarti1": "/assets/temple-images/padmanabhaswamy-temple-kerala/aarti1.jpg",
    "aarti2": "/assets/temple-images/padmanabhaswamy-temple-kerala/aarti2.jpg"
  },
  "padmanabhaswamy-temple-kerala": {
    "timingImage": "/assets/temple-images/padmanabhaswamy-temple-kerala/timing.jpg",
    "aarti1": "/assets/temple-images/padmanabhaswamy-temple-kerala/aarti1.jpg",
    "aarti2": "/assets/temple-images/padmanabhaswamy-temple-kerala/aarti2.jpg"
  },
  "kamakhya-temple": {
    "timingImage": "/assets/temple-images/kamakhya-temple-guwahati/timing.jpg",
    "aarti1": "/assets/temple-images/kamakhya-temple-guwahati/aarti1.jpg",
    "aarti2": "/assets/temple-images/kamakhya-temple-guwahati/aarti2.jpg"
  },
  "kamakhya-temple-guwahati": {
    "timingImage": "/assets/temple-images/kamakhya-temple-guwahati/timing.jpg",
    "aarti1": "/assets/temple-images/kamakhya-temple-guwahati/aarti1.jpg",
    "aarti2": "/assets/temple-images/kamakhya-temple-guwahati/aarti2.jpg"
  },
  "kedarnath-temple": {
    "timingImage": "/assets/temple-images/kedarnath-temple/timing.jpg",
    "aarti1": "/assets/temple-images/kedarnath-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/kedarnath-temple/aarti2.jpg"
  },
  "badrinath-temple": {
    "timingImage": "/assets/temple-images/badrinath-temple/timing.jpg",
    "aarti1": "/assets/temple-images/badrinath-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/badrinath-temple/aarti2.jpg"
  },
  "mansa-devi-haridwar": {
    "timingImage": "/assets/temple-images/mansa-devi-temple-haridwar/timing.jpg",
    "aarti1": "/assets/temple-images/mansa-devi-temple-haridwar/aarti1.jpg",
    "aarti2": "/assets/temple-images/mansa-devi-temple-haridwar/aarti2.jpg"
  },
  "mansa-devi-temple-haridwar": {
    "timingImage": "/assets/temple-images/mansa-devi-temple-haridwar/timing.jpg",
    "aarti1": "/assets/temple-images/mansa-devi-temple-haridwar/aarti1.jpg",
    "aarti2": "/assets/temple-images/mansa-devi-temple-haridwar/aarti2.jpg"
  },
  "har-ki-pauri": {
    "timingImage": "/assets/temple-images/har-ki-pauri-haridwar/timing.jpg",
    "aarti1": "/assets/temple-images/har-ki-pauri-haridwar/aarti1.jpg",
    "aarti2": "/assets/temple-images/har-ki-pauri-haridwar/aarti2.jpg"
  },
  "har-ki-pauri-haridwar": {
    "timingImage": "/assets/temple-images/har-ki-pauri-haridwar/timing.jpg",
    "aarti1": "/assets/temple-images/har-ki-pauri-haridwar/aarti1.jpg",
    "aarti2": "/assets/temple-images/har-ki-pauri-haridwar/aarti2.jpg"
  },
  "shrinathji-nathdwara": {
    "timingImage": "/assets/temple-images/shrinathji-temple-nathdwara/timing.jpg",
    "aarti1": "/assets/temple-images/shrinathji-temple-nathdwara/aarti1.jpg",
    "aarti2": "/assets/temple-images/shrinathji-temple-nathdwara/aarti2.jpg"
  },
  "shrinathji-temple-nathdwara": {
    "timingImage": "/assets/temple-images/shrinathji-temple-nathdwara/timing.jpg",
    "aarti1": "/assets/temple-images/shrinathji-temple-nathdwara/aarti1.jpg",
    "aarti2": "/assets/temple-images/shrinathji-temple-nathdwara/aarti2.jpg"
  },
  "salasar-balaji": {
    "timingImage": "/assets/temple-images/salasar-balaji-rajasthan/timing.jpg",
    "aarti1": "/assets/temple-images/salasar-balaji-rajasthan/aarti1.jpg",
    "aarti2": "/assets/temple-images/salasar-balaji-rajasthan/aarti2.jpg"
  },
  "salasar-balaji-rajasthan": {
    "timingImage": "/assets/temple-images/salasar-balaji-rajasthan/timing.jpg",
    "aarti1": "/assets/temple-images/salasar-balaji-rajasthan/aarti1.jpg",
    "aarti2": "/assets/temple-images/salasar-balaji-rajasthan/aarti2.jpg"
  },
  "govind-dev-ji-jaipur": {
    "timingImage": "/assets/temple-images/govind-dev-ji-temple-jaipur/timing.jpg",
    "aarti1": "/assets/temple-images/govind-dev-ji-temple-jaipur/aarti1.jpg",
    "aarti2": "/assets/temple-images/govind-dev-ji-temple-jaipur/aarti2.jpg"
  },
  "govind-dev-ji-temple-jaipur": {
    "timingImage": "/assets/temple-images/govind-dev-ji-temple-jaipur/timing.jpg",
    "aarti1": "/assets/temple-images/govind-dev-ji-temple-jaipur/aarti1.jpg",
    "aarti2": "/assets/temple-images/govind-dev-ji-temple-jaipur/aarti2.jpg"
  },
  "akshardham-delhi": {
    "timingImage": "/assets/temple-images/akshardham-temple-delhi/timing.jpg",
    "aarti1": "/assets/temple-images/akshardham-temple-delhi/aarti1.jpg",
    "aarti2": "/assets/temple-images/akshardham-temple-delhi/aarti2.jpg"
  },
  "akshardham-temple-delhi": {
    "timingImage": "/assets/temple-images/akshardham-temple-delhi/timing.jpg",
    "aarti1": "/assets/temple-images/akshardham-temple-delhi/aarti1.jpg",
    "aarti2": "/assets/temple-images/akshardham-temple-delhi/aarti2.jpg"
  },
  "iskcon-vrindavan": {
    "timingImage": "/assets/temple-images/iskcon-temple-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/iskcon-temple-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/iskcon-temple-vrindavan/aarti2.jpg"
  },
  "iskcon-temple-vrindavan": {
    "timingImage": "/assets/temple-images/iskcon-temple-vrindavan/timing.jpg",
    "aarti1": "/assets/temple-images/iskcon-temple-vrindavan/aarti1.jpg",
    "aarti2": "/assets/temple-images/iskcon-temple-vrindavan/aarti2.jpg"
  },
  "hanuman-garhi-ayodhya": {
    "timingImage": "/assets/temple-images/hanuman-garhi-ayodhya/timing.jpg",
    "aarti1": "/assets/temple-images/hanuman-garhi-ayodhya/aarti1.jpg",
    "aarti2": "/assets/temple-images/hanuman-garhi-ayodhya/aarti2.jpg"
  },
  "vindhyavasini-temple": {
    "timingImage": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/timing.jpg",
    "aarti1": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/aarti1.jpg",
    "aarti2": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/aarti2.jpg"
  },
  "vindhyavasini-devi-temple-mirzapur": {
    "timingImage": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/timing.jpg",
    "aarti1": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/aarti1.jpg",
    "aarti2": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/aarti2.jpg"
  },
  "chintpurni-temple": {
    "timingImage": "/assets/temple-images/chintpurni-devi-temple-himachal/timing.jpg",
    "aarti1": "/assets/temple-images/chintpurni-devi-temple-himachal/aarti1.jpg",
    "aarti2": "/assets/temple-images/chintpurni-devi-temple-himachal/aarti2.jpg"
  },
  "chintpurni-devi-temple-himachal": {
    "timingImage": "/assets/temple-images/chintpurni-devi-temple-himachal/timing.jpg",
    "aarti1": "/assets/temple-images/chintpurni-devi-temple-himachal/aarti1.jpg",
    "aarti2": "/assets/temple-images/chintpurni-devi-temple-himachal/aarti2.jpg"
  },
  "jwala-ji-temple": {
    "timingImage": "/assets/temple-images/jwala-ji-temple-himachal/timing.jpg",
    "aarti1": "/assets/temple-images/jwala-ji-temple-himachal/aarti1.jpg",
    "aarti2": "/assets/temple-images/jwala-ji-temple-himachal/aarti2.jpg"
  },
  "jwala-ji-temple-himachal": {
    "timingImage": "/assets/temple-images/jwala-ji-temple-himachal/timing.jpg",
    "aarti1": "/assets/temple-images/jwala-ji-temple-himachal/aarti1.jpg",
    "aarti2": "/assets/temple-images/jwala-ji-temple-himachal/aarti2.jpg"
  },
  "naina-devi-temple": {
    "timingImage": "/assets/temple-images/naina-devi-temple-bilaspur/timing.jpg",
    "aarti1": "/assets/temple-images/naina-devi-temple-bilaspur/aarti1.jpg",
    "aarti2": "/assets/temple-images/naina-devi-temple-bilaspur/aarti2.jpg"
  },
  "naina-devi-temple-bilaspur": {
    "timingImage": "/assets/temple-images/naina-devi-temple-bilaspur/timing.jpg",
    "aarti1": "/assets/temple-images/naina-devi-temple-bilaspur/aarti1.jpg",
    "aarti2": "/assets/temple-images/naina-devi-temple-bilaspur/aarti2.jpg"
  },
  "bajreshwari-devi-kangra": {
    "timingImage": "/assets/temple-images/bajreshwari-devi-temple-kangra/timing.jpg",
    "aarti1": "/assets/temple-images/bajreshwari-devi-temple-kangra/aarti1.jpg",
    "aarti2": "/assets/temple-images/bajreshwari-devi-temple-kangra/aarti2.jpg"
  },
  "bajreshwari-devi-temple-kangra": {
    "timingImage": "/assets/temple-images/bajreshwari-devi-temple-kangra/timing.jpg",
    "aarti1": "/assets/temple-images/bajreshwari-devi-temple-kangra/aarti1.jpg",
    "aarti2": "/assets/temple-images/bajreshwari-devi-temple-kangra/aarti2.jpg"
  },
  "chamunda-devi-kangra": {
    "timingImage": "/assets/temple-images/chamunda-devi-temple-kangra/timing.jpg",
    "aarti1": "/assets/temple-images/chamunda-devi-temple-kangra/aarti1.jpg",
    "aarti2": "/assets/temple-images/chamunda-devi-temple-kangra/aarti2.jpg"
  },
  "chamunda-devi-temple-kangra": {
    "timingImage": "/assets/temple-images/chamunda-devi-temple-kangra/timing.jpg",
    "aarti1": "/assets/temple-images/chamunda-devi-temple-kangra/aarti1.jpg",
    "aarti2": "/assets/temple-images/chamunda-devi-temple-kangra/aarti2.jpg"
  },
  "kollur-mookambika": {
    "timingImage": "/assets/temple-images/kollur-mookambika-temple-karnataka/timing.jpg",
    "aarti1": "/assets/temple-images/kollur-mookambika-temple-karnataka/aarti1.jpg",
    "aarti2": "/assets/temple-images/kollur-mookambika-temple-karnataka/aarti2.jpg"
  },
  "kollur-mookambika-temple-karnataka": {
    "timingImage": "/assets/temple-images/kollur-mookambika-temple-karnataka/timing.jpg",
    "aarti1": "/assets/temple-images/kollur-mookambika-temple-karnataka/aarti1.jpg",
    "aarti2": "/assets/temple-images/kollur-mookambika-temple-karnataka/aarti2.jpg"
  },
  "udupi-sri-krishna": {
    "timingImage": "/assets/temple-images/udupi-sri-krishna-matha/timing.jpg",
    "aarti1": "/assets/temple-images/udupi-sri-krishna-matha/aarti1.jpg",
    "aarti2": "/assets/temple-images/udupi-sri-krishna-matha/aarti2.jpg"
  },
  "udupi-sri-krishna-matha": {
    "timingImage": "/assets/temple-images/udupi-sri-krishna-matha/timing.jpg",
    "aarti1": "/assets/temple-images/udupi-sri-krishna-matha/aarti1.jpg",
    "aarti2": "/assets/temple-images/udupi-sri-krishna-matha/aarti2.jpg"
  },
  "kukke-subrahmanya": {
    "timingImage": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/timing.jpg",
    "aarti1": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/aarti1.jpg",
    "aarti2": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/aarti2.jpg"
  },
  "kukke-subrahmanya-temple-karnataka": {
    "timingImage": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/timing.jpg",
    "aarti1": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/aarti1.jpg",
    "aarti2": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/aarti2.jpg"
  },
  "dharmasthala-manjunatha": {
    "timingImage": "/assets/temple-images/dharmasthala-manjunatha-temple/timing.jpg",
    "aarti1": "/assets/temple-images/dharmasthala-manjunatha-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/dharmasthala-manjunatha-temple/aarti2.jpg"
  },
  "dharmasthala-manjunatha-temple": {
    "timingImage": "/assets/temple-images/dharmasthala-manjunatha-temple/timing.jpg",
    "aarti1": "/assets/temple-images/dharmasthala-manjunatha-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/dharmasthala-manjunatha-temple/aarti2.jpg"
  },
  "kanaka-durga-vijayawada": {
    "timingImage": "/assets/temple-images/kanaka-durga-temple-vijayawada/timing.jpg",
    "aarti1": "/assets/temple-images/kanaka-durga-temple-vijayawada/aarti1.jpg",
    "aarti2": "/assets/temple-images/kanaka-durga-temple-vijayawada/aarti2.jpg"
  },
  "kanaka-durga-temple-vijayawada": {
    "timingImage": "/assets/temple-images/kanaka-durga-temple-vijayawada/timing.jpg",
    "aarti1": "/assets/temple-images/kanaka-durga-temple-vijayawada/aarti1.jpg",
    "aarti2": "/assets/temple-images/kanaka-durga-temple-vijayawada/aarti2.jpg"
  },
  "srisailam-mallikarjuna": {
    "timingImage": "/assets/temple-images/srisailam-mallikarjuna-temple/timing.jpg",
    "aarti1": "/assets/temple-images/srisailam-mallikarjuna-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/srisailam-mallikarjuna-temple/aarti2.jpg"
  },
  "srisailam-mallikarjuna-temple": {
    "timingImage": "/assets/temple-images/srisailam-mallikarjuna-temple/timing.jpg",
    "aarti1": "/assets/temple-images/srisailam-mallikarjuna-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/srisailam-mallikarjuna-temple/aarti2.jpg"
  },
  "arunachaleswarar-tiruvannamalai": {
    "timingImage": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/timing.jpg",
    "aarti1": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/aarti1.jpg",
    "aarti2": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/aarti2.jpg"
  },
  "arunachaleswarar-temple-tiruvannamalai": {
    "timingImage": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/timing.jpg",
    "aarti1": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/aarti1.jpg",
    "aarti2": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/aarti2.jpg"
  },
  "palani-murugan-temple": {
    "timingImage": "/assets/temple-images/palani-murugan-temple-tamil-nadu/timing.jpg",
    "aarti1": "/assets/temple-images/palani-murugan-temple-tamil-nadu/aarti1.jpg",
    "aarti2": "/assets/temple-images/palani-murugan-temple-tamil-nadu/aarti2.jpg"
  },
  "palani-murugan-temple-tamil-nadu": {
    "timingImage": "/assets/temple-images/palani-murugan-temple-tamil-nadu/timing.jpg",
    "aarti1": "/assets/temple-images/palani-murugan-temple-tamil-nadu/aarti1.jpg",
    "aarti2": "/assets/temple-images/palani-murugan-temple-tamil-nadu/aarti2.jpg"
  },
  "dagdusheth-ganpati-pune": {
    "timingImage": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/timing.jpg",
    "aarti1": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/aarti1.jpg",
    "aarti2": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/aarti2.jpg"
  },
  "shreemant-dagdusheth-halwai-ganpati-pune": {
    "timingImage": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/timing.jpg",
    "aarti1": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/aarti1.jpg",
    "aarti2": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/aarti2.jpg"
  },
  "trimbakeshwar-nashik": {
    "timingImage": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/timing.jpg",
    "aarti1": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/aarti1.jpg",
    "aarti2": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/aarti2.jpg"
  },
  "trimbakeshwar-shiva-temple-nashik": {
    "timingImage": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/timing.jpg",
    "aarti1": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/aarti1.jpg",
    "aarti2": "/assets/temple-images/trimbakeshwar-shiva-temple-nashik/aarti2.jpg"
  },
  "vaishno-devi": {
    "timingImage": "/assets/tample-timing.svg",
    "aarti1": "/assets/aarti1.svg",
    "aarti2": "/assets/aarti2.svg"
  },
  "dwarkadhish-temple": {
    "timingImage": "/assets/dwarkadhish-timing.svg",
    "aarti1": "/assets/tample/tample11.svg",
    "aarti2": "/assets/aarti1.svg"
  },
  "dwarkadhish": {
    "timingImage": "/assets/dwarkadhish-timing.svg",
    "aarti1": "/assets/tample/tample11.svg",
    "aarti2": "/assets/aarti1.svg"
  },
  "ayodhya": {
    "timingImage": "/assets/ram-timing.svg",
    "aarti1": "/assets/tample/ayodhya-temple.svg",
    "aarti2": "/assets/temple-images/hanuman-garhi-ayodhya/aarti1.jpg"
  },
  "ayodhya-temple": {
    "timingImage": "/assets/ram-timing.svg",
    "aarti1": "/assets/tample/ayodhya-temple.svg",
    "aarti2": "/assets/temple-images/hanuman-garhi-ayodhya/aarti1.jpg"
  },
  "kashi-vishwanath": {
    "timingImage": "/assets/kashi-timing.svg",
    "aarti1": "/assets/banner/vr-darshan/temples/aarti.webp",
    "aarti2": "/assets/tample/tample9.svg"
  },
  "kashi-vishwanath-temple": {
    "timingImage": "/assets/kashi-timing.svg",
    "aarti1": "/assets/banner/vr-darshan/temples/aarti.webp",
    "aarti2": "/assets/tample/tample9.svg"
  },
  "ramanathaswamy-temple": {
    "timingImage": "/assets/rameshwaram-timing.svg",
    "aarti1": "/assets/tample/tample12.svg",
    "aarti2": "/assets/aarti2.svg"
  },
  "ramanathaswamy": {
    "timingImage": "/assets/rameshwaram-timing.svg",
    "aarti1": "/assets/tample/tample12.svg",
    "aarti2": "/assets/aarti2.svg"
  },
  "rameshwaram": {
    "timingImage": "/assets/rameshwaram-timing.svg",
    "aarti1": "/assets/tample/tample12.svg",
    "aarti2": "/assets/aarti2.svg"
  },
  "amarnath-temple": {
    "timingImage": "/assets/amarnath-timing.svg",
    "aarti1": "/assets/tample/tample3.svg",
    "aarti2": "/assets/aarti1.svg"
  },
  "amarnath": {
    "timingImage": "/assets/amarnath-timing.svg",
    "aarti1": "/assets/tample/tample3.svg",
    "aarti2": "/assets/aarti1.svg"
  },
  "kedarnath": {
    "timingImage": "/assets/kedarnath-timing.svg",
    "aarti1": "/assets/temple-images/kedarnath-temple/aarti1.jpg",
    "aarti2": "/assets/temple-images/kedarnath-temple/aarti2.jpg"
  }
};

export const getTempleMedia = (slug) => {
  if (!slug) {
    return {
      timingImage: "/assets/tample-timing.svg",
      aarti1: "/assets/banner/vr-darshan/temples/aarti.webp",
      aarti2: "/assets/aarti2.svg"
    };
  }
  const s = slug.toLowerCase().trim();
  const media = templeMediaMap[s] || {};
  return {
    timingImage: media.timingImage || "/assets/tample-timing.svg",
    aarti1: media.aarti1 || "/assets/banner/vr-darshan/temples/aarti.webp",
    aarti2: media.aarti2 || "/assets/aarti2.svg"
  };
};

export default templeMediaMap;
